<script setup>

import InlineMessage from "primevue/inlinemessage";
import {watch} from "vue";

const props = defineProps({
    selectedDate: Date,
    availableTimeSlots: Object,
    theme: Object,
});

watch(() => props.selectedDate, () => {
    selectedTimeSlot.value = null;
});

const selectedTimeSlot = defineModel();
const getSlotClass = (timeSlot) => {
    if (timeSlot.last) {
        return 'cursor-no-drop bg-neutral-100 dark:bg-neutral-900 text-neutral-500';
    }
    if (timeSlot.disabled) {
        return 'cursor-no-drop bg-neutral-200 dark:bg-neutral-900 text-neutral-500';
    }
    if (selectedTimeSlot.value === timeSlot.id) {
        return `ring-2 ring-${props.theme.color}-500 bg-${props.theme.color}-100 dark:!bg-${props.theme.color}-800`;
    }
    return `cursor-pointer hover:bg-${props.theme.color}-50 hover:dark:bg-${props.theme.color}-600 dark:bg-transparent bg-white`;

}
</script>

<template>
    <div v-if="!!availableTimeSlots?.all_taken || !!availableTimeSlots?.slots">
        <template v-if="!availableTimeSlots?.all_taken && selectedDate">
            <div class="grid grid-cols-2 md:grid-cols-4 gap-3 rounded-lg p-3">
                <div
                    class="p-3 border border-neutral-300 flex flex-col items-center justify-center transition-all duration-200 ease-in-out hover:shadow-md"
                    :class="[{
                        'rounded-lg': theme.roundness === 1,
                        'rounded-xl': theme.roundness === 2,
                        'rounded-2xl': theme.roundness === 3,
                        'border-neutral-700 dark:border-neutral-700 bg-transparent hover:bg-transparent': theme.darkMode
                    }, getSlotClass(timeSlot)]"
                    @click="!timeSlot.disabled && !timeSlot.last && (selectedTimeSlot = timeSlot.id)"
                    v-for="(timeSlot, t) in availableTimeSlots?.slots" :key="t"
                >
                    <div class="flex items-center gap-1">
                        <i class="pi pi-arrow-down opacity-50" style="font-size: .7rem"></i>
                        <div class="text-center">
                            <p class="text-md font-medium">{{ timeSlot.time_start }}</p>
                            <p class="text-md font-medium">{{ timeSlot.time_end }}</p>
                        </div>
                        <i class="pi pi-arrow-down opacity-50" style="font-size: .7rem"></i>
                    </div>
                    <p v-if="!timeSlot.disabled && !timeSlot.last"
                       class="text-sm text-neutral-600 dark:text-neutral-200 text-center">{{ timeSlot.diff }}</p>
                    <p v-else-if="timeSlot.last" class="text-xs text-neutral-600 text-center">{{
                            $t('widget.too_long')
                        }}</p>
                    <p v-else class="text-sm text-neutral-600">{{ $t('widget.unavailable') }}</p>
                </div>
            </div>
        </template>
        <InlineMessage v-else :severity="availableTimeSlots?.severity" class="m-4 mr-0">{{ availableTimeSlots?.message }}</InlineMessage>
    </div>
    <div v-else class="flex justify-center items-center h-full">
        <div class="pi pi-spinner pi-spin !text-4xl"> </div>
    </div>
</template>

<style scoped lang="scss">

</style>
